import { type SelectionEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { deselectAllReducer } from './deselect-all';
import { extendToCellReducer } from './extend-to-cell';
import { extendToColumnReducer } from './extend-to-column';
import { extendToRowReducer } from './extend-to-row';
import { previewSelectionActionReducer } from './preview-selection-action';
import { selectCellReducer } from './select-cell';
import { selectColumnsReducer } from './select-columns';
import { selectRowsReducer } from './select-rows';
import { toggleReducer } from './toggle';
import { type Reducer } from './types';

/**
 * Main reducer that routes events to their specific reducers. Add new reducers
 * here as you create them. Returns noop for unhandled events.
 */
export const selectionsReducer: Reducer = (
  prev: SelectionState,
  event: SelectionEvent
) => {
  if (event.type === 'selectCell') {
    return selectCellReducer(prev, event);
  }

  if (event.type === 'extendToCell') {
    return extendToCellReducer(prev, event);
  }

  if (event.type === 'selectRows') {
    return selectRowsReducer(prev, event);
  }

  if (event.type === 'extendToRow') {
    return extendToRowReducer(prev, event);
  }

  if (event.type === 'extendToColumn') {
    return extendToColumnReducer(prev, event);
  }

  if (event.type === 'toggleRow') {
    return toggleReducer(prev, {
      axis: 'row',
      primaryCoord: event.row,
      source: event.source,
    });
  }

  if (event.type === 'selectColumns') {
    return selectColumnsReducer(prev, event);
  }

  if (event.type === 'toggleColumn') {
    return toggleReducer(prev, {
      axis: 'col',
      primaryCoord: event.col,
      source: event.source,
    });
  }

  if (event.type === 'deselectAll') {
    return deselectAllReducer(prev, event);
  }

  if (event.type === 'previewSelectionAction') {
    return previewSelectionActionReducer(prev, event);
  }

  return { next: prev, delta: { kind: 'noop' } };
};
